import React from 'react'
import PropTypes from 'prop-types'
import { Button, Popconfirm } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import numeral from 'numeral'
import styles from './styles.css'

const Spacer = () => <div style={{ width: 12 }} />

const Total = props => (
  <div className={styles.total}>
    {`${props.label}: ${props.value < 0 ? '-' : ''}£${numeral(Math.abs(props.value)).format('0,0.00')}`}
  </div>
)

const Footer = props => {

  const {
    editing,
    saving,
    totals,
    onClickEdit,
    onClickSave,
    onClickCancel,
  } = props

  return (
    
    <div className={styles.wrapper}>

      <div className={styles.buttons}>

        {editing ? (

          <React.Fragment>

            <Button type='primary' onClick={onClickSave} loading={saving}>
              Save Changes
            </Button>

            <Spacer />

            <Popconfirm
              title='Cancel your changes?'
              okText='Yes'
              cancelText='No'
              onConfirm={onClickCancel}
            >
              <Button>
                Cancel
              </Button>
            </Popconfirm>

          </React.Fragment>

        ) : (

          <Button onClick={onClickEdit}>
            <EditOutlined />
            Edit Invoice
          </Button>

        )}

      </div>

      <div className={styles.totals}>

        <Total label='Total' value={totals.total} />

      </div>

    </div>
    
  )

}

Total.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
}

Footer.propTypes = {
  editing: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  totals: PropTypes.object.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
}

export default Footer
